import { Input } from "./input";
import { Textarea, TextareaWithCounter } from "./textarea";
import { Button } from "./button";

export { Input, Textarea, TextareaWithCounter, Button };
export const FormGroup = ({
  children,
  label,
  required = false,
  error,
  hint,
  // Color customization
  labelColor = "var(--text, #374151)",
  errorColor = "var(--error, #EF4444)",
  hintColor = "var(--icon, #687076)",
  requiredColor = "var(--error, #EF4444)",
  // Typography customization
  labelFontSize = "14px",
  labelFontWeight = "500",
  errorFontSize = "12px",
  hintFontSize = "12px",
  // Position/Spacing customization
  marginBottom = "16px",
  marginTop = "0",
  marginLeft = "0",
  marginRight = "0",
  labelMarginBottom = "6px",
  errorMarginTop = "4px",
  hintMarginTop = "4px",
  // Layout customization
  labelPosition = "top",
  labelWidth = "auto",
  labelAlign = "left",
  gap = "8px",
  // Additional options
  className = "",
  style = {},
}) => {
  const isHorizontal = labelPosition === "left" || labelPosition === "right";

  const containerStyles = {
    marginBottom,
    marginTop,
    marginLeft,
    marginRight,
    ...(isHorizontal && {
      display: "flex",
      flexDirection: labelPosition === "right" ? "row-reverse" : "row",
      alignItems: "flex-start",
      gap,
    }),
    ...style,
  };

  const labelContainerStyles = {
    ...(isHorizontal && {
      width: labelWidth,
      flexShrink: 0,
      paddingTop: "8px",
    }),
  };

  const labelStyles = {
    display: "block",
    fontSize: labelFontSize,
    fontWeight: labelFontWeight,
    color: labelColor,
    marginBottom: isHorizontal ? "0" : labelMarginBottom,
    textAlign: labelAlign,
  };

  const errorStyles = {
    color: errorColor,
    fontSize: errorFontSize,
    marginTop: errorMarginTop,
  };

  const hintStyles = {
    color: hintColor,
    fontSize: hintFontSize,
    marginTop: hintMarginTop,
  };

  const contentStyles = {
    ...(isHorizontal && {
      flex: 1,
    }),
  };

  const renderLabel = () => {
    if (!label) return null;

    return (
      <div style={labelContainerStyles}>
        <label style={labelStyles}>
          {label}
          {required && (
            <span style={{ color: requiredColor, marginLeft: "2px" }}>*</span>
          )}
        </label>
      </div>
    );
  };

  return (
    <div style={containerStyles} className={className}>
      {(labelPosition === "top" || labelPosition === "left") && renderLabel()}
      <div style={contentStyles}>
        {children}
        {hint && !error && <div style={hintStyles}>{hint}</div>}
        {error && <div style={errorStyles}>{error}</div>}
      </div>
      {labelPosition === "right" && renderLabel()}
    </div>
  );
};
